<template>
    <b-container>
        <div class="body-content">
            <Spinner size="32" message="Loading..." v-if="isLoading"> </Spinner>
            <b-alert :show = "showDismissibleAlert" dismissible 
                @dismissed="showDismissibleAlert=false"
                :variant="variant">
                {{alertText}}
            </b-alert>
            
            <b-table show-empty head-variant="dark"
                    empty-text="Loading..."
                      stacked="md"
                      bordered
                      striped
                      :items="schemeEligibility"
                      :fields="fields"
                      style="font-size:12px"
                     
            >
                <template v-slot:cell(action)="row">
                    <b-button size="sm" @click.stop="applyforScheme(row.item, row.index, $event.target)" 
                      class="mr-1 pt-0 pb-0" variant="outline-danger" v-b-tooltip.hover title="Apply for the post">
                      Apply
                    </b-button>
                </template>
            </b-table>
        </div>
    </b-container>
</template>

<script>
import apis from "@/apis";
import Spinner from "vue-simple-spinner";
import Formatter from '@/Formatter.js';
export default {
    name: "SchemeEligibility",
  components: { Spinner },
  props: ["SchemeID"],
  watch: {
    SchemeID(newValue, oldValue) {
      this.inputSchemeID = newValue;
      this.getSchemeEligibility();
    }
  },
  data() {
    return {
      inputSchemeID: 1,
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: true,
      isLoading2: false,
      schemeEligibility: [
        {
          SrNo: "",
          EligibiltyCriteria: ""
        }
      ],
      fields: [
        
        {
          key: "SchemeNotice",
          label: "Notice",
          sortable: true
        },
        { key: "SchemeGuidelienDate", label: "Date",formatter: "Formatter.convertDateFormat", sortable: true },
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [5, 10, 15, 20, 50],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: "",
      selectedSchemeId: "",
      RegType: 1
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(f => f.sortable).map(f => {
        return { text: f.label, value: f.key };
      });
    }
  },
  methods: {
      getSchemeEligibility() {
      let promise = apis.getSchemeGuidelines(this.SchemeID);

      promise
        .then(response => {
          if (response.status == 200) {
            let rspns = response.body;
            //this.$store.dispatch("setSchemeList", rspns);
            this.schemeEligibility=response.body;
            
          } else {
            this.alertText = "Unable to Load Scheme List, " + response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = "Unable to Load Scheme List, " + err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    }
  },
  mounted() {
    this.schemeEligibility = [];
    this.getSchemeEligibility();
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/SchemeDetails/SchemeGuidelines.vue